import MapService from '../../../../Core/Services/MapService';

export default function MapTooltip({ visible, x, y, room }) {
  if (!visible || !room) return null;

  const info = MapService.getRoomTooltipInfo(room);
  const lines = info.split('\n');

  return (
    <div
      className="absolute bg-white !border !border-solid border-gray-300 rounded shadow-lg px-3 py-2 text-sm pointer-events-none z-20"
      style={{
        left: x + 12,
        top: y + 12,
        maxWidth: 220,
      }}
    >
      {lines.map((line, i) => (
        <div key={i}>{line}</div>
      ))}
    </div>
  );
}
